import { render, staticRenderFns } from "./GoodsSelect.vue?vue&type=template&id=0db4976a&scoped=true&"
import script from "./GoodsSelect.vue?vue&type=script&lang=js&"
export * from "./GoodsSelect.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSelect.vue?vue&type=style&index=0&id=0db4976a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db4976a",
  null
  
)

export default component.exports